/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from "react";
import OperatorCard from "../../../components/Card/Operator";
// import AppointementCard from "../../../components/Card/appointement";
import DoctorCard from "../../../components/Card/Doctor";
import Queuemodal from "../../../components/Modal";
import TechnicianQueuepatientDetailshell from "./shell";
import * as R from "ramda";
import postService from "../../../services/httpService";
import userTrackService from "../../../services/usertrack-service";
import Storage from "../../../services/local-store";
import { Modal, Input, Spin, Popover } from "antd";
import { SyncOutlined } from '@ant-design/icons';

{/*<SyncOutlined style={{ fontSize: 48, position: 'relative', left: '-19px', bottom: '10px' }} spin />*/}

const $ = require("jquery");
const { Search } = Input;
const antIcon = (
  // <Icon
  //   type="sync"
  //   style={{ fontSize: 48, left: "-19px", bottom: "10px" }}
  //   spin
  // />


<SyncOutlined style={{ fontSize: 48, position: 'relative', left: '-19px', bottom: '10px' }} spin />

);
class TechnicianPatientDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      patients: "",
      QueueList: "",
      billingPatients: "",
      allpatients: [],
      appointemntPatients: "",
      showPatients: true,
      showAppointments: false,
      latestCardId: null,
      latestContainer: null,
      latestDropIndex: null,
      isLoading: false,
      queueDoctors: "",
    };
  }
  componentDidMount() {
    this.horizantalScroll();
  }

  horizantalScroll() {
    let scaleWidth = 0;
    $(".card-dynamic").each(function (ele) {
      scaleWidth += $(this).outerWidth(true);
    });
    //console.log(scaleWidth);
  }

  modalChanges() {
    this.setState({ visible: false });
  }

  showModal = () => {
    this.setState({ visible: true });
  };
  showPatients = () => {
    this.setState({ showPatients: true, showAppointments: false });
  };
  showAppointments = () => {
    this.setState({ showPatients: false, showAppointments: true });
  };
  refreshCard = () => {
    if (this.state.showPatients) {
      this.showPatients();
    }
    if (this.state.showAppointments) {
      this.showAppointments();
    }
    this.newPatientsData();
  };
  // componentWillMount() {
    componentDidMount() {
    window.ondragover = function (e) {
      e.preventDefault();
      return false;
    };
    window.ondrop = function (e) {
      e.preventDefault();
      return false;
    };
    // this.storePatientsData();
    this.setState({ isLoading: true });
    this.newPatientsData();
    this.queuePatientsData();
    this.getQueueDoctors();
  }

  componentDidUpdate() {
    // console.log($(window).outerHeight())
    // console.log($('header').outerHeight())
    // console.log($('.breadCrums').outerHeight())
    // console.log($('.custom-container').outerHeight())

    $(".custom-container").css({
      height:
        $(window).outerHeight() -
        ($("header").outerHeight() + $(".breadCrums").outerHeight()),
      "padding-bottom": "0px",
    });
    this.horizantalScroll();
    $(".b-card").css({
      height:
        // $(".custom-container").outerHeight() - $(".h-card").outerHeight() - 20,
        $(".custom-container").outerHeight() - 120,
    });
    $(".b-card-scroll").css({
      height:
        $(".b-card").outerHeight() - $(".b-card-footer").outerHeight() - 13,
    });
    $("footer").hide();
    // this.interval = setInterval(() => {
    //     this.newPatientsData()
    //     //this.queuePatientsData()
    // }, 30000);
  }

  componentWillUnmount() {
    $(".custom-container").removeAttr("style");
    $("footer").show();
    //clearInterval(this.interval);
  }

  // storePatientsData() {
  //     postService('newPatientsList', 'GET', 'null').then(res => {
  //         if (res) {
  //             this.setState((state) => ({patients: res.data, billingPatients: res.data.billing, appointemntPatients: res.data.appointments}));
  //         }
  //     });
  //     postService('getQueuesBasedOnService', 'GET', 'null').then(res => {
  //         if (res) {
  //             this.setState((state) => ({QueueList: res.data}));
  //         }
  //     });
  // }
  getQueueDoctors() {
    postService("getQueueDoctors", "GET", "null").then((res) => {
      if (res) {
     
        this.setState({ queueDoctors: res.data });
      }
    });
  }
  newPatientsData() {
    postService("newPatientsList", "GET", "null").then((res) => {
      if (res) {
        this.setState((state) => ({
          patients: res.data,
          billingPatients: res.data.billing,
          appointemntPatients: res.data.appointments,
          allpatients: res.data.billing,
          allappointemntPatients: res.data.appointments,
        }));
      }
    });
  }
  queuePatientsData() {
    postService("getQueuesAndPatientsForTechnician", "GET", "null").then(
      (res) => {
        this.deActivateLoader();
        if (res) {
          this.setState((state) => ({ QueueList: res.data }));
        }
      }
    );
  }
  refreshData() {
    this.newPatientsData();
    this.queuePatientsData();
    this.getQueueDoctors();
  }
  refreshQueueListData() {
    this.queuePatientsData();
  }
  getPatients(props, key) {
    let PatientsObj = R.pick(["patients"], props);
    let emptyReq = "";
    if (!R.isEmpty(PatientsObj)) {
      let Patients = PatientsObj.patients;
      if (!R.isEmpty(Patients)) {
        let PatientsObj = R.pick([key], Patients);
        if (!R.isEmpty(PatientsObj)) {
          if (!R.isEmpty(PatientsObj[key])) {
            let Patients = PatientsObj[key];
            return Patients;
          }
        }
      }
    }
    return emptyReq;
  }

  getQueueList(props) {
    let QueuesObj = R.pick(["QueueList"], props);
    let emptyReq = "";
    if (!R.isEmpty(QueuesObj)) {
      let Queues = QueuesObj.QueueList;
      return Queues;
    }
    return emptyReq;
  }
  onFileDrop(files, item) {
    let lid = this.state.latestCardId;
    let cid = this.state.latestContainer;
    let latestDropIndex = this.state.latestDropIndex;
    let { QueueList } = this.state;
 
    QueueList = QueueList.filter((s) => s.display_status != "1");
    if (item !== null) {
      let belowDropIndex = null;
      let ccard = QueueList.filter((s) => s.roomnumber == item.roomnumber);
      let fromqueuelistid = "";
      let toqueuelistid = "";
      let fromservicegroup = "";
      let toservicegroup = "";
      if (ccard[0] !== undefined && ccard[0] !== null) {
        toqueuelistid = ccard[0].queuelistid;
        toservicegroup = ccard[0].service_group_name;
      }
      if (cid !== undefined && cid !== null) {
        let sourcequeueobj = QueueList.filter((s) => s.roomnumber == cid);
        if (sourcequeueobj[0] !== undefined && sourcequeueobj[0] !== null) {
          fromqueuelistid = sourcequeueobj[0].queuelistid;
          fromservicegroup = sourcequeueobj[0].service_group_name;
        }
      } else {
        if (
          lid.service_group_name !== undefined &&
          lid.service_group_name !== null
        ) {
          fromservicegroup = lid.service_group_name;
        }
      }

      let obj = {
        patientId: lid.id,
        queueListId: toqueuelistid,
        fromqueueListId: fromqueuelistid,
      };
   
      // if (fromservicegroup === toservicegroup) {
   
      this.setState({ latestDropIndex: null, isLoading: true });
      let Userlogobj = {
        user: JSON.parse(Storage.get("user")),
        action: "drag and drop",
        date: new Date(),
        meta: obj,
      };
      userTrackService(Userlogobj);
      postService("assignPatientToRoom", "POST", { data: obj }).then((res) => {
        let Userlogobjres = {
          user: JSON.parse(Storage.get("user")),
          action: "drag and drop - response",
          date: new Date(),
          meta: res,
        };
        userTrackService(Userlogobjres);
        //this.setState({ isLoading: false });
        //if (res) {
        this.refreshData();
        //}
      });
      // }
      // else if (fromservicegroup !== toservicegroup) {
      //     this.setState({ latestDropIndex: null });
      //     Modal.error({
      //         zIndex: 1040,
      //         maskClosable: false,
      //         centered: true,
      //         title: 'Error',
      //         content: 'Oops! you are trying to drop a patient in different service group.',
      //     });

      // }
    } else {
  
      let obj1 = {
        patientId: lid.id,
      };
      // postService('removePatientFromQueue', 'POST', { "data": obj1 }).then(res => {
      //     if (res) {
      //         this.refreshData();
      //     }
      // });
    }
  }
  dropover11() {}
  onDragEnter() {}
  setLatestCard(r, cont) {
    this.state.latestCardId = r;
    this.state.latestContainer = cont;
  }
  setLatestDropIndex(i) {
  
    this.state.latestDropIndex = i;
    // this.state.latestContainer = cont;
  }
  getSearchResults(value) {
    let actualPatients = this.state.allpatients || [];
    if (value) {
      let searchKey = value;
      let searchresults = actualPatients.filter((s) => {
        if (
          R.includes(R.toLower(searchKey), R.toLower(s.name ? s.name : "null"))
        ) {
          return s;
        } else if (
          R.includes(R.toLower(searchKey), R.toLower(s.umr ? s.umr : "null"))
        ) {
          return s;
        } else if (
          R.includes(
            R.toLower(searchKey),
            R.toLower(s.patienttype ? s.patienttype : "null")
          )
        ) {
          return s;
        }
      });
      this.setState({ billingPatients: searchresults });
    } else {
      this.setState({ billingPatients: actualPatients });
    }
  }
  getSearchAppResults(value) {
    let actualAppPatients = this.state.allappointemntPatients || [];
    if (value) {
      let searchKey = value;
      let searchresults = actualAppPatients.filter((s) => {
        if (
          R.includes(R.toLower(searchKey), R.toLower(s.name ? s.name : "null"))
        ) {
          return s;
        } else if (
          R.includes(
            R.toLower(searchKey),
            R.toLower(s.phonenumber ? s.phonenumber : "null")
          )
        ) {
          return s;
        } else if (
          R.includes(
            R.toLower(searchKey),
            R.toLower(s.patienttype ? s.patienttype : "null")
          )
        ) {
          return s;
        }
      });
      this.setState({ appointemntPatients: searchresults });
    } else {
      this.setState({ appointemntPatients: actualAppPatients });
    }
  }
  activateLoader() {
    this.setState({ isLoading: true });
  }
  deActivateLoader() {
    this.setState({ isLoading: false });
  }
  render() {
    //console.log("state values----"); console.log(this.state);
    let showPatients = this.state.showPatients;
    let showAppointments = this.state.showAppointments;
    let billingPatients = this.state.billingPatients || []; //Storage.getJson('billingPatients');
    let appointemntPatients = this.state.appointemntPatients || [];
    let QueueList = this.state.QueueList || []; // Storage.getJson('QueueList');
    let queueDoctors = this.state.queueDoctors || [];
    // console.log("QueueList")
    // console.log(QueueList);
    // console.log(R.sortBy(R.prop('roomnumber'), QueueList));
    if (!R.isEmpty(QueueList)) {
      QueueList = QueueList.filter((s) => s.display_status != "1");
      QueueList = R.sortBy(R.prop("roomnumber"), QueueList);
    }
   
    return (
      <div className="q-p-details">
        <div className="col">
          {/* <div className="q-p-d-list w-100"> */}
          <div className="card-row">
            {QueueList.map((item, key) => {
              return (
                <div className="card-dynamic mr-2" key={key}>
                  <DoctorCard
                    props={this.state}
                    {...this.props}
                    item={item}
                    queueDoctors={queueDoctors}
                    refreshData={this.refreshData.bind(this)}
                    viewtype="technician"
                  />
                  <div class="PatientCardsDisplay card b-card">
                    <TechnicianQueuepatientDetailshell
                      roomId={item.roomnumber}
                      setLatestCard={this.setLatestCard.bind(this)}
                      item={item}
                      props={this.state}
                      refreshQueueListData={this.refreshQueueListData.bind(
                        this
                      )}
                      refreshData={this.refreshData.bind(this)}
                      activateLoader={this.activateLoader.bind(this)}
                      deActivateLoader={this.deActivateLoader.bind(this)}
                      viewtype="technician"
                    />
                  </div>
                </div>
              );
            })}
          </div>

          {this.state.isLoading ? (
            <div className="loader">
              <Spin indicator={antIcon} tip="Loading..." />{" "}
            </div>
          ) : (
            ""
          )}
          {/* </div> */}
        </div>
      </div>
    );
  }
}

export default TechnicianPatientDetails;
